import Button from '@/components/atoms/button';
import Input from '@/components/atoms/input';
import { MAX_PASSWORD_LENGTH } from '@/consts';
import { INPUT_MSG } from '@/consts/message';
import { InputValidatorType } from '@/core/presenter/viewModel';
import clsx from 'clsx';

interface IProps {
  newPassword: string;
  confirmPassword: string;
  isNewPasswordValid: boolean;
  isNotMatchPassword: boolean;
  isCheckPasswordDisabled: boolean;
  isConfirmPasswordValid?: boolean;
  onChangeNewPassword: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onChangeConfirmPassword: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onBlurNewPassword: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onKeyDownCheckNewPassword: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onClickCompleteBtn: () => void;
  onBlurPassword: (e: React.SyntheticEvent<HTMLInputElement>) => void;
}

const CheckPwdSettingView = ({
  newPassword,
  confirmPassword,
  isNewPasswordValid,
  isNotMatchPassword,
  isCheckPasswordDisabled,
  isConfirmPasswordValid,
  onChangeNewPassword,
  onChangeConfirmPassword,
  onBlurNewPassword,
  onKeyDownCheckNewPassword,
  onClickCompleteBtn,
  onBlurPassword,
}: IProps) => {
  return (
    <div className="container-style2">
      <div className="inner-set-pnum">
        <h3 className="form-title body-l-n fw-b">비밀번호 재설정</h3>
        <div className="form-group-info">
          <div className="pwd_setting_div">
            <label className="pwd_setting_label">새로운 비밀번호를 입력해주세요</label>
          </div>
          <div className="input-group">
            <Input
              type="password"
              className="body-n-n"
              id="auth-code"
              placeholder="영문, 숫자, 특수문자 포함 8~20자 입력"
              value={newPassword}
              maxLength={MAX_PASSWORD_LENGTH}
              validatorType={InputValidatorType.PASSWORD}
              onChange={onChangeNewPassword}
              onBlur={onBlurNewPassword}
            />
          </div>
          {isNewPasswordValid && newPassword.length > 0 && (
            <div className="alert-msg-join-sms-2 body-s-n">
              <p className="setting_set_password">{INPUT_MSG.INVALID_PASSWORD}</p>
            </div>
          )}
          <div className="pwd_setting_div">
            <label className="pwd_setting_label">비밀번호를 다시 입력해주세요</label>
          </div>
          <div className="input-group">
            <Input
              type="password"
              className="body-n-n"
              id="auth-code"
              placeholder="비밀번호 확인"
              value={confirmPassword}
              maxLength={MAX_PASSWORD_LENGTH}
              validatorType={InputValidatorType.PASSWORD}
              onChange={onChangeConfirmPassword}
              onKeyDown={onKeyDownCheckNewPassword}
              onBlur={onBlurPassword}
            />
          </div>
          {isNotMatchPassword && isConfirmPasswordValid && (
            <div className="alert-msg-join-sms-2 body-s-n">
              <p className="setting_set_password">{INPUT_MSG.CHECK_PWD_FAILED}</p>
            </div>
          )}
        </div>
        <div className="button-area magin-top-10">
          <Button
            caption="완료"
            className={clsx('body-n-n fw-b', {
              show_important: !isNotMatchPassword,
              solid: !isNotMatchPassword,
              disabled: isNotMatchPassword || isCheckPasswordDisabled || confirmPassword.length === 0,
            })}
            disabled={isNotMatchPassword || isCheckPasswordDisabled || confirmPassword.length === 0}
            onClick={onClickCompleteBtn}
          />
        </div>
      </div>
    </div>
  );
};

export default CheckPwdSettingView;
